/**
 * The jersey colour ("preset") of a womens lineup, decided in one place.
 *
 * This used to be worked out three ways: the editor took the preset layer from
 * anywhere in the stack, the editor preview trusted whatever the editor passed
 * it, and the published template looked only at the *last* layer. The preset
 * layer is created before any uploaded photo, so the photo is normally last --
 * and the published template fell back to white while both previews showed the
 * red jersey that had been picked.
 */

// The preset colours offered in the editor (PresetColors in LeftSidebar/EditTab)
// mapped to the class the stylesheet keys each jersey's artwork off. Anything
// else -- the white jersey's #363d43 included -- is the `gray` variant.
const PRESET_CLASS_BY_COLOR = {
  "#ad042b": "red",
  "#111111": "black",
};

// What the editor starts on before anything is picked, so a template that was
// never given a jersey renders the same everywhere.
export const DEFAULT_PRESET_COLOR = "#363d43";

export const getPresetClass = (color) => PRESET_CLASS_BY_COLOR[color] || "gray";

// The colour a saved lineup was made with. Deliberately `find` over the whole
// stack, not the last layer: it is exactly how the editor recovers the jersey
// when it reopens the template (ImageEditorModal, `initialLayers.find(isPreset)`),
// which is what keeps the published render in step with what was edited.
export const getSavedPresetColor = (layers) =>
  (Array.isArray(layers) ? layers : []).find((layer) => layer?.isPreset)
    ?.backgroundUrl;
